import React from "react";
import cx from "classnames";
import { twSpecList, twSpecFeature } from "../../../config/twSpecList";
import { getQuery } from "lib";

//lib
import { getData } from "common-lib/lib";

const FeatureImage = ({ rule, gameId, imgsdomain, onLoad, imageLink }) => {
  const lang = getQuery("language");
  const originGameId = getQuery("gameid");
  const switchIcon = getData(rule, ["icon", "link"]);
  const resultUrl =
    twSpecList.indexOf(originGameId) !== -1 &&
    twSpecFeature[originGameId].indexOf(switchIcon) !== -1
      ? `tw/${switchIcon}`
      : switchIcon;
  const getGameId = () => {
    if(originGameId === "VPCQS34" && lang === "id") {
      return "VPCQS34";
    }
    return gameId;
  }
  return (
    <img
      className={cx("object-fit-scale mb20 h100", {
        w100: imageLink !== "F" && imageLink !== "W",
      })}
      alt=""
      onLoad={(e) => onLoad(e)}
      src={`${imgsdomain}/vp_project/common/${getGameId()}/symbolList/${resultUrl}.png`}
    />
  );
};

export default FeatureImage;
